import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getMiscellaneous({ commit }, id) {
    return axios.get(`/miscellaneous/${id}`)
  },
  convertToProduct({ commit }, data) {
    return axios.post('/miscellaneous/convert-to-product', data)
  },
}
